import PageHeader from '../../components/page-header/page-header.component';
import SignInForm from '../../components/sign-in-form/sign-in-form.component';
import SignUpForm from '../../components/sign-up-form/sign-up-form.component';

import './authentication.styles.scss';

const Authentication = () => {
  return (
    <div className="auth-page">
      <PageHeader
        overline="Votre compte"
        title="Connexion"
        lead="Connectez-vous pour retrouver vos commandes, ou créez un compte en quelques secondes."
      />

      <div className="auth-grid">
        <SignInForm />
        <SignUpForm />
      </div>
    </div>
  );
};

export default Authentication;
